var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "top" }, [
      _c(
        "div",
        {
          staticClass: "log",
          on: {
            click: function($event) {
              _vm.go("")
            }
          }
        },
        [_vm._v("\n            APopups-Gallery\n        ")]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu" }, [
      _c("a", { attrs: { href: "changelog.html" } }, [_vm._v("Changelog")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("b", [_vm._v("for mobile.")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }